export const sectionLabelSx = {
  fontWeight: 600,
  fontSize: '1rem',
} as const;

export const linkSx = {
  cursor: 'pointer',
  transition: 'color 0.2s',
  '&:hover': { color: 'primary.main' },
} as const;
